import { Add, Delete } from "@mui/icons-material"
import { Box, Button, Typography } from "@mui/material"
import React from "react";
import { useTranslation } from "react-i18next"

interface IValidationRuleActionHeader {
    rowsSelected: number[];
    onClickDelete: (input: number[]) => void;
    addNew: () => void;
}

export const ValidationRuleActionHeader: React.FC<IValidationRuleActionHeader> = ({
    onClickDelete,
    rowsSelected,
    addNew
}) => {
    const { t } = useTranslation();

    return (
            <Box
                display="flex"
                justifyContent="space-between"
                mb="30px"
            >
                <Box
                    display="flex"
                >
                    <Button
                        variant="outlined"
                        sx={{
                            background: "#FFFFFF 0% 0% no-repeat padding-box",
                            border: "1px solid #22638D",
                            borderRadius: "4px",
                            opacity: 1,
                            ":disabled": {
                                opacity: 0.6
                            }
                        }}
                        startIcon={<Delete sx={{ color: "#22638D" }} />}
                        disabled={rowsSelected.length <= 0}
                        onClick={() => onClickDelete(rowsSelected)}
                    >
                        <Typography
                            sx={{
                                textAlign: "left",
                                font: "normal normal 600 14px/21px Segoe UI",
                                letterSpacing: "0px",
                                color: "#22638D",
                                opacity: 1
                            }}
                            textTransform="none"
                        >
                            {t("ValidationRule.RemoveLines")}
                        </Typography>
                    </Button>
                </Box>
                <Button
                    startIcon={<Add />}
                    variant='contained'
                    sx={{
                        background: "#22638D 0% 0% no-repeat padding-box",
                        borderRadius: "4px",
                        opacity: 1,
                    }}
                    onClick={addNew}
                >
                    <Typography
                        textTransform="none"
                        sx={{
                            textAlign: "left",
                            font: "normal normal 600 14px/21px Segoe UI",
                            letterSpacing: "0px",
                            color: "#FFFFFF",
                            opacity: 1,
                        }}
                    >
                        {t("ValidationRule.AddNewActivity")}
                    </Typography>
                </Button>
            </Box>
    )
}